<template>
  <v-container fill-height fluid align-start pa-0>
    <v-layout column>
      <div class="ass-result-header">
        <child-clip :child="child"></child-clip>
        <p class="result-header-label">{{ $t('LBL.RESULT') }}:</p>
        <p class="result-header-text">{{ $t('LBL.T_LIKELIHOOD', {LIKELIHOOD: $t(likelihoodText)}) }}</p>
      </div>
      <div class="ass-result-body ma-3">
        <v-card class="white">
          <v-card-text v-html="$t(resultContentHTML, {CHILD_FNAME: child.firstName, LIKELIHOOD: $t(likelihoodText).toUpperCase()})">
          </v-card-text>
          <v-card-actions class="theme--dark primary" >
            <v-btn flat @click="goToResources">{{ $t('LBL.RESOURCES') }}</v-btn>
            <v-btn flat to="/home">{{ $t('LBL.MY_ASSESSMENTS') }}</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  UPDATE_APP_STEP
} from '@/store/mutation-types'
import ChildClip from '@/components/elements/ChildClip'

export default {
  name: 'AssessmentResultPage',
  components: {
    'child-clip': ChildClip
  },
  computed: {
    child: function () {
      const childId = parseInt(this.$route.params.childId, 10)
      return this.userChildren && this.userChildren.length
        ? this.userChildren.filter((child) => child.id === childId).pop()
        : {}
    },
    ...mapState({
      appReady: state => state.appReady,
      userChildren: state => state.userChildren
    })
  },
  created () {
    this.updateAppStep(3)
  },
  data () {
    return {
      likelihoodText: parseInt(this.$route.params.result, 10) === 2
        ? 'LBL.HIGHER'
        : 'LBL.LOWER',
      resultContentHTML: parseInt(this.$route.params.result, 10) === 2
        ? 'TXT.ASS_RESULT_PAGE_RESULT_HIGH_HTML'
        : 'TXT.ASS_RESULT_PAGE_RESULT_HTML'
    }
  },
  methods: {
    goToResources () {
      window.open('http://asdetect.org/')
    },
    ...mapMutations({
      updateAppStep: UPDATE_APP_STEP
    })
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';

.ass-result-header {
  padding: 24px;
  border-bottom-left-radius: 40px 40px;
  border-bottom-right-radius: 40px 40px;
  @include bg-gradient-orange-dark();

  .result-header-label, .result-header-text {
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    padding: 0;
    margin: 0;
  }

  .result-header-text {
    font-size: 24px;
    line-height: 32px;
    text-transform: uppercase;
  }
}

.ass-result-body {
  .card__text /deep/ {
    u, strong {
      color: $amber-darken4 !important;

      .lang-zh & {
        color: $blue-darken2 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AssessmentResultPage.vue